import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../response.js';
import { acceptJson } from '../shared.js';

/**
 * Lists all stores for an opco
 */ const list = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl) {
        return unwrapResponse((yield fetch(`${apiUrl}/list`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson)
        })));
    });
    return function list(apiUrl) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Retrieve details of a single store using the store code.
 */ const getDetailsByCode = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/${request.code}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson)
        })));
    });
    return function getDetailsByCode(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Function to retrieve a list of stores based on a filter parameter
 * Currently only supports slug lookup
 */ const getStoresByFilter = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/retrieve/filter?name=${request.filter}&value=${request.value}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson)
        })));
    });
    return function getStoresByFilter(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { getDetailsByCode, getStoresByFilter, list };
//# sourceMappingURL=stores.js.map
